/*
 * TransactionIdValue
 * @module components
 * @flow
 */

import React, { Fragment } from 'react';
import styled from 'styled-components/macro';
// $FlowIssue
import { FormattedMessage } from 'react-intl';

import { Tooltip } from '~/components';

import messages from './messages';

// $FlowIssue
export type TransactionIdValueProps = DeviceQuery & {
  value: string,
};

const Ellipsis = styled.a`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/**
 * DataValue React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {string} [props.value] - transaction ID
 * @param {$PropertyType<DeviceQuery, 'device'>} [props.device] - device mode
 * @example <caption>Simple usage</caption>
 * <DataValue value="123" />
 * @returns {React.Node<*>} React-component
 */
export const TransactionIdValue = ({
  value,
  device,
}: TransactionIdValueProps) => {
  const transactionId = (
    <Ellipsis
      href={`${process.env.REACT_APP_BLOCKCHAIN_BTC_TXID_ENDPOINT ||
        'https://www.blockchain.com/btc/tx'}/${value}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {value}
    </Ellipsis>
  );

  return device === 'desktop' ? (
    <Tooltip
      placement="left"
      overlay={<FormattedMessage {...messages.desc} tagName="span" />}
    >
      {transactionId}
    </Tooltip>
  ) : (
    <Fragment>{transactionId}</Fragment>
  );
};

TransactionIdValue.defaultProps = {
  value: '',
};
